import axiosInstance from "../../../../Services/Interceptor";
import {
  FISCAL_YEAR_FAIL,
  FISCAL_YEAR_REQUEST,
  FISCAL_YEAR_SUCCESS,
} from "../../../Constant/ApaManagement/FiscalYear/FiscalYearConstant";

export const getFiscalYearData = (id) => async (dispatch) => {
  try {
    dispatch({ type: FISCAL_YEAR_REQUEST });

    const res = await axiosInstance.get(
      `apa-config/api/v1/fiscal-years/all?statusId=${id}`
    );

    if (res.data.status === 200) {
      dispatch({
        type: FISCAL_YEAR_SUCCESS,
        payload: res?.data?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: FISCAL_YEAR_FAIL,
      error: error.message,
    });
  }
};
